import { Route } from '@angular/router';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

export const actionReplaysRoutes: Route[] = [
    {
        path: DC_ROUTING.ACTION_REPLAYS,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/action-replays/action-replays.component').then((c) => c.ActionReplaysComponent),
            },
            {
                path: 'view',
                loadComponent: () =>
                    import('./pages/action-replay-view/action-replay-view.component').then(
                        (c) => c.ActionReplayViewComponent
                    ),
            },
        ],
    },
];
